module.exports = __webpack_public_path__ + "img/07.c5af21db.jpg";